import React from "react";
import { Row, Col } from "reactstrap";
import "./index.scss";
import { Button } from "shared";
import { useHistory } from "react-router-dom";
import t from "utils/Lang";

type StoreInformationProps = {
  storeData: any;
};

const StoreInformation = ({ storeData }: StoreInformationProps) => {
  const history = useHistory();
  return (
    <Row className="store-information-container">
      <Col md={12}>
        <div style={{ display: "flex", marginBottom: 15 }}>
          <img
            className="store-information__avatar"
            src={storeData?.data?.photos?.photo?.url}
            alt="Card image cap"
          />
          <div className="store-information__info">
            <span className="store-information__info__name">
              {storeData?.data?.name}
              <span className="store-information__info__status">
                {storeData.data?.status?.name}
              </span>
            </span>
            <span style={{ marginTop: 4 }}>
              {t().store_listing__address}:{" "}
              <span className="store-information__info__value">
                {storeData?.data?.full_address}
              </span>
            </span>
            <div
              style={{ marginTop: 12, display: "flex", alignItems: "center" }}
            >
              {!!storeData.data?.store_format?.name && (
                <span className="store-information__info__site-tag">
                  {storeData.data.store_format.name}
                </span>
              )}
              {!!storeData?.data?.store_type?.name && (
                <span
                  className="store-information__info__site-tag"
                  style={{ marginLeft: 8 }}
                >
                  {storeData.data.store_type.name}
                </span>
              )}
              <Button
                label={t().action__edit}
                type="primary"
                size="small"
                style={{ marginLeft: 8 }}
                onClick={() =>
                  history.push(`/store/${storeData?.data?.id}/edit`)
                }
              />
              <Button
                label={t().action_view__site_detail}
                type="primary"
                size="small"
                style={{ marginLeft: 8 }}
                onClick={() =>
                  history.push(`/sitev2/${storeData?.data?.site?.id}`)
                }
              />
              <Button
                label={t().contract}
                type="primary"
                size="small"
                style={{ marginLeft: 8 }}
                onClick={() =>
                  history.push(`/contract/${storeData?.data?.site?.id}`)
                }
              />
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default StoreInformation;
